import React from 'react'

const AppleAltIcon = props => (
  <svg viewBox="0 0 37 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M30.5602 23.3438C30.5103 17.7983 35.1009 15.1004 35.3108 14.9748C32.7109 11.1843 28.6813 10.6664 27.2652 10.6251C23.8808 10.269 20.5979 12.6503 18.8738 12.6503C17.1154 12.6503 14.4605 10.6595 11.5991 10.718C7.91701 10.7748 4.47236 12.9066 2.58313 16.2171C-1.31576 22.967 1.59207 32.8863 5.3275 38.3424C7.19608 41.0162 9.37953 43.998 12.2375 43.893C15.0334 43.7795 16.0778 42.1122 19.452 42.1122C22.7951 42.1122 23.7758 43.893 26.6905 43.8259C29.6913 43.7795 31.5805 41.1418 33.3837 38.4456C35.5431 35.3846 36.4102 32.3667 36.4447 32.2118C36.3758 32.1877 30.6187 29.9888 30.5602 23.3438Z"
      fill="white"
    />
    <path
      d="M25.0517 7.03556C26.5556 5.15493 27.5845 2.59639 27.2989 0C25.1223 0.0963539 22.4003 1.50553 20.8328 3.34486C19.446 4.96567 18.2072 7.62228 18.5272 10.1206C20.9722 10.303 23.4826 8.88693 25.0517 7.03556Z"
      fill="white"
    />
  </svg>
)

export default AppleAltIcon
